console.log('123-v5');
function featuredOurProduct() {
  let mainBox = document.getElementById("featured-our-product");
  if (!mainBox) return;
  let featuredFlick = new Flickity(mainBox, {
    cellAlign: "left",
    wrapAround: true,
    watchCSS: true,
    prevNextButtons: false,
    autoPlay: 3000,
  });
};

function instagramIndex(tp) {
  let mainBox = document.getElementById("instagram_index");
  if (!mainBox) return;
  let showDots =
    mainBox.dataset.size <= 3 && window.innerWidth > 960 ? false : true;
  let featuredFlick = new Flickity(mainBox, {
    cellAlign: "left",
    wrapAround: true,
    watchCSS: true,
    prevNextButtons: false,
    autoPlay: false,
    pageDots: showDots,
    draggable: showDots,
  });
  if (tp == "d") {
    featuredFlick.destroy();
    instagramIndex();
  }
};

function load11js() {
  if (window.MSInputMethodContext && document.documentMode) {
    var scripts = document.getElementsByTagName("script")[0];
    var polyfill = document.createElement("script");
    polyfill.defer = true;
    polyfill.src = "{{ 'ie11CustomProperties.min.js' | asset_url }}";

    scripts.parentNode.insertBefore(polyfill, scripts);
  }
}

function userSvg()
{
  let elem = document.getElementById('header-user-svg');
  let platf = document.getElementById('header-user-platform');

  elem.addEventListener('click', function() {
    let curr = elem.dataset.platf;
    if( curr == 'false' ) {
      platf.style.display = "block";
      elem.dataset.platf = "true";
    }else {
      platf.style.display = "none";
      elem.dataset.platf = "false";
    }
  });
}

window.onload = function () {
  featuredOurProduct();
  instagramIndex();
  load11js();
  userSvg();
};
window.onresize = function () {
  instagramIndex("d");
};

// Fix: product swatch variant/price update (all browsers + mobile + WeChat)
(function() {
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
      do { if (el.matches(s)) return el; el = el.parentElement || el.parentNode; }
      while (el && el.nodeType === 1);
      return null;
    };
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' USD';
  }

  function doSwitch(label, container) {
    var radio = document.getElementById(label.getAttribute('for'));
    if (!radio || radio.checked) return;

    radio.checked = true;

    var jsonEl = container.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var variants = JSON.parse(jsonEl.textContent).product.variants;
    var selectedValues = [];
    container.querySelectorAll('.swatch[data-option-index]').forEach(function(swatch) {
      var idx = parseInt(swatch.getAttribute('data-option-index'));
      var checked = swatch.querySelector('input[type="radio"]:checked');
      selectedValues[idx] = checked ? checked.value : '';
    });

    var title = selectedValues.join(' / ');
    var found = variants.find(function(v) { return v.title === title; });
    if (!found) return;

    var productSelect = container.querySelector('select[name="id"]');
    if (productSelect && productSelect.value !== String(found.id)) {
      productSelect.value = found.id;
      productSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var priceStr = formatMoney(found.price);
    // Try multiple selectors — mobile/PageFly may use different markup
    var priceSelectors = [
      '.price-item--regular',
      '.price-item--sale',
      '.product__price .price-item',
      '[data-price]',
      '[data-regular-price]',
      '[data-sale-price]',
      '.price__regular .price-item',
      '.price__sale .price-item',
      '.pf-product-price [data-pf-type="ProductPrice"] span'
    ];
    var updated = false;
    priceSelectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) {
        el.textContent = priceStr;
        updated = true;
      });
    });
    // Fallback: search entire document for any element whose text looks like a price
    if (!updated) {
      document.querySelectorAll('.product__price *, .price *, [class*="price"]').forEach(function(el) {
        if (/^\$\d[\d,]*\.\d{2}/.test(el.textContent.trim())) {
          el.textContent = priceStr;
          updated = true;
        }
      });
    }

    // Update SKU with price appended
    var skuStr = found.sku ? found.sku + ' (' + priceStr + ')' : priceStr;
    container.querySelectorAll('.variant-sku').forEach(function(el) {
      el.textContent = skuStr;
    });
    // Also update the SKU paragraph
    container.querySelectorAll('.product-single__meta p').forEach(function(p) {
      if (p.textContent.indexOf('SKU:') !== -1) {
        p.textContent = 'SKU: ' + skuStr;
      }
    });
  }

  function handleEvent(e) {
    var target = e.target;
    // On mobile, touchend target might be a child text node – try parent too
    var label = target.closest('.swatch-element label[for]');
    if (!label) {
      // Also try the swatch-element div itself (touch may land there)
      var swatchEl = target.closest('.swatch-element');
      if (swatchEl) label = swatchEl.querySelector('label[for]');
    }
    if (!label) return;

    var container = label.closest('[data-section-type="product"]');
    if (!container) return;

    doSwitch(label, container);
  }

  var root = document.documentElement;
  root.addEventListener('click', handleEvent, true);
  root.addEventListener('touchend', handleEvent, true);
  // Also try touchstart as fallback for some mobile browsers
  root.addEventListener('touchstart', function(e) {
    // Don't process here, just ensure the target is tracked;
    // actual switch happens on touchend/click
  }, true);
})();
